import { useEffect, useLayoutEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";

import {
  CookieChoice,
  OPEN_COOKIE_BANNER_EVENT,
  readCookieConsent,
  saveCookieConsent,
} from "../../cookies/consent";

import "./CookieBanner.css";

export const CookieBanner = () => {
  const { t } = useTranslation();
  const barRef = useRef<HTMLDivElement>(null);
  const [open, setOpen] = useState(() => readCookieConsent() === null);

  useEffect(() => {
    const show = () => setOpen(true);
    window.addEventListener(OPEN_COOKIE_BANNER_EVENT, show);
    return () => window.removeEventListener(OPEN_COOKIE_BANNER_EVENT, show);
  }, []);

  useLayoutEffect(() => {
    const root = document.documentElement;
    if (!open || !barRef.current) {
      root.style.removeProperty("--pp-cookie-space");
      return;
    }

    const node = barRef.current;
    const update = () => {
      root.style.setProperty(
        "--pp-cookie-space",
        `${node.offsetHeight + 12}px`
      );
    };
    update();

    if (typeof ResizeObserver === "undefined") {
      return () => root.style.removeProperty("--pp-cookie-space");
    }

    const observer = new ResizeObserver(update);
    observer.observe(node);
    return () => {
      observer.disconnect();
      root.style.removeProperty("--pp-cookie-space");
    };
  }, [open]);

  const choose = (choice: CookieChoice) => {
    saveCookieConsent(choice);
    setOpen(false);
  };

  if (!open) return null;

  return (
    <div
      ref={barRef}
      className="pp-cookies"
      role="dialog"
      aria-modal="false"
      aria-labelledby="pp-cookies-title"
    >
      <p id="pp-cookies-title">
        {t("cookies.body")} <Link to="/privacy">{t("cookies.privacy")}</Link>
      </p>
      <div className="pp-cookies-actions">
        <button type="button" onClick={() => choose("essential")}>
          {t("cookies.essential")}
        </button>
        <button
          type="button"
          className="pp-cookies-accept"
          onClick={() => choose("all")}
        >
          {t("cookies.accept")}
        </button>
      </div>
    </div>
  );
};
